import React, { FC, useEffect, useState } from "react";
import {
  Modal,
  Card,
  Form,
  Input,
  Button,
  InputNumber,
  Row,
  Col,
} from "antd";

interface SummaryFormValues {
  monthTillDate: string;
  target: number;
  totalBorrower: number;
  totalOutstanding: number;
}

interface UpdateSummaryModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit?: (values: SummaryFormValues) => Promise<void> | void;
  initialData?: Partial<SummaryFormValues>;
}

const UpdateSummaryModal: FC<UpdateSummaryModalProps> = ({
  open,
  onCancel,
  onSubmit,
  initialData,
}) => {
  const [form] = Form.useForm<SummaryFormValues>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      form.resetFields(); // reset first
      if (initialData) {
        form.setFieldsValue(initialData);
      }
    }
  }, [open, initialData, form]);

  const handleFinish = async (values: SummaryFormValues) => {
    try {
      setLoading(true);
      await onSubmit?.(values);
      form.resetFields();
      onCancel(); // close modal after success (optional)
    } finally {
      setLoading(false);
    }
  }; // ✅ FUNCTION CLOSED PROPERLY

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={600}
      destroyOnClose
    >
      <Card bordered={false}>
        <Form<SummaryFormValues>
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          <Row gutter={16}>


            <Col span={12}>
              <Form.Item
                label="Enter Target in (Rupees)"
                name="target"
                normalize={(value) =>
                  typeof value === "string" ? value.trim() : value
                }

                rules={[
                  { required: true, message: "Please enter Target amount" },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  placeholder="Enter Target"
                  formatter={(value) =>
                    value
                      ? `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : ""
                  }
                />
              </Form.Item>
            </Col>



          </Row>

          <Form.Item>
            <div className="flex justify-center space-x-4">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="w-[20%] mr-3"
              >
                Submit
              </Button>

              <Button
                type="default"
                onClick={onCancel}
                className="w-[20%]"
              >
                Cancel
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </Modal>
  );
};

export default UpdateSummaryModal;
